module.exports = __webpack_public_path__ + "static/media/S3.17d7d2c3.png";